import { User } from '../types'

export const getAbbreviationFromUser = (user: User): string => {
  if (user.first_name && user.last_name) {
    return user.first_name.substring(0, 1).toUpperCase() + user.last_name.substring(0, 1).toUpperCase()
  }
  if (user.name) {
    const nameSplit = user.name.split(' ')
    if (nameSplit.length > 1) {
      return nameSplit[0].substring(0, 1).toUpperCase() + nameSplit[1].substring(0, 1).toUpperCase()
    }
  }
  return '??'
}

/**
 * get a string for a users name from a user
 * @param user user object with all the user's info
 * @returns a string representing the user's name
 */
export const getUserName = (user: User | undefined | string): string => {
  if (!user) return 'Backbone User'
  if (typeof user === 'string' || user instanceof String) {
    return user as string
  }
  if (user.first_name && user.last_name) return `${user.first_name} ${user.last_name}`
  if (user.firstName && user.lastName) return `${user.firstName} ${user.lastName}`
  if (user.name) return user.name
  return 'Backbone User'
}
